import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', component: require(page+'home.vue').default, meta:{title:"Home"}},
      { path: '/empresa', component: require(page+'company/index.vue').default, meta:{title:"Empresa"}},
      { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{title:"Contacto"}},
      { path: '/validador', component: require(page+'validator/index.vue').default, meta:{title:"Validador"}},
      { path: '/coa/:id', component: require(page+'data-sheet/index.vue').default, meta:{title:"COA"}},
      { path: '/coa/:id/:ide', component: require(page+'data-sheet/index.vue').default, meta:{title:"COA"}},
      { path: '/eum-legal', component: require(page+'text-pages/eum-legal.vue').default, meta:{title:"EUM Legal"}},
      { path: '/cromatografia-para-cannabinoide', component: require(page+'text-pages/cromatografia.vue').default, meta:{title:"Cromatografia para cannabinoide"}},
      { path: '/comparar', component: require(page+'compare/index.vue').default, meta:{title:"Comparar"}},

      { path: '/politica-de-devolucion', component: require(page+'text-pages/devolucion.vue').default, meta:{title:"Política de envío, devolución y reembolso"}},
      { path: '/terminos-y-condiciones', component: require(page+'text-pages/terminos.vue').default, meta:{title:"Términos y condiciones"}},
      { path: '/aviso-de-privacidad', component: require(page+'text-pages/aviso.vue').default, meta:{title:"Aviso de privacidad"}},

      { path: '/blog', component: require(page+'blog/results.vue').default, meta:{title:"Blog"}},
      { path: '/blog/:id', component: require(page+'blog/detail.vue').default, meta:{title:"Blog"}},

      { path: '/productos/:id?/:sub?', component: require(page+'products/results.vue').default, meta:{title:"Productos"}},
      { path: '/producto/:id', component: require(page+'products/detail.vue').default, meta:{title:"Producto"}},

      { path: '/login', component: require(page+'user-access/login.vue').default, meta:{title:"Iniciar sesión"}},
      { path: '/recuperar-contrasena', component: require(page+'user-access/reset-password.vue').default, meta:{title:"Recuperar contraseña"}},
      { path: '/registrarse', component: require(page+'user-access/register.vue').default, meta:{title:"Registrarse"}},

      { path: '/cart/:step?', component: require(page+'carrito/index.vue').default, meta:{title:"Mi carrito de compras"}},
      { path: '/mercadopago', component: require(page+'carrito/mercadopagostatus.vue').default, meta:{title:"Compra con Mercado pago"}},

      { path: '/usuario', component: require(page+'usuario-cuenta/index.vue').default, meta:{ title: 'Mi datos' },
  			children: [
  			{
  				path: '/',
  				component: require(page+'usuario-cuenta/mis-datos.vue').default,
  				meta:{ title: 'Mis datos' }
  			},
  			{
  				path: 'contrasena',
  				component: require(page+'usuario-cuenta/contrasena.vue').default,
  				meta:{ title: 'Cambiar contraseña' }
  			},
        {
            path: 'pedidos',
            component: require(page+'usuario-cuenta/historial-compras.vue').default,
            meta:{ title: 'Pedidos' }
        },
        {
          path: 'certificados-guardados',
          component: require(page+'usuario-cuenta/certificados.vue').default,
          meta:{ title: 'Certificados guardados' }
      },
        {
            path: 'pedido/:id',
            component: require(page+'usuario-cuenta/orderdetails.vue').default,
            meta:{ title: 'Pedidos' }
        },
  	  	]
  		},
      //https://extractoseum.online/#/mercadopago?collection_id=95464111729&collection_status=approved&payment_id=95464111729&status=approved&external_reference=null&payment_type=credit_card&merchant_order_id=25935807820&preference_id=2098489658-f814a375-6293-400c-8271-3456bd1af7be&site_id=MLM&processing_mode=aggregator&merchant_account_id=null
	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Extractos EUM", filter: (title)=>{ return title+" - Extractos EUM"; } }
);

// export {routes};
export default MyRouter;
